import classNames from 'classnames'
import type { FC } from 'react'
import React from 'react'

import { useTableContext } from './table-context'
import type { TableFootProps } from './types'
import { BoxPrivate } from '../_primitives/box/box'

const defaultStyles = {
  borderTop: 'lightGray',
  fontWeight: 'bold'
}

export const TableFoot: FC<TableFootProps> = ({
  variant = 'foot',
  className,
  children,
  ...props
}) => {
  const { variant: tableVariant } = useTableContext()
  return (
    <BoxPrivate
      __themeKey="tables"
      variant={tableVariant ? `${tableVariant}.foot` : variant}
      as="tfoot"
      className={classNames(
        {
          'csg-tui-tfoot': true
        },
        className
      )}
      {...props}
      __css={defaultStyles}
    >
      {children}
    </BoxPrivate>
  )
}

export default TableFoot
